// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images//calendar.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images//hide-toyota.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/images//hide-lexus.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/images//Artboard 3down.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/images//Artboard 3up.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scrollable-widgets {
    min-height: 8rem;
    max-height: 8rem;
    min-width: 10.5rem;
    /* max-width: 10.5rem; */
}
.dashboardDiv{
    background-color: #f0f0f0 !important;
    padding: 1rem;
    border-bottom-right-radius: 1.25rem;
    border-bottom-left-radius: 1.25rem;


}
.dashboardDiv .react-multi-carousel-item{
    padding-right: 1rem;

}
.react-multiple-carousel__arrow--left {
    margin-left: -50px;
}
.react-multiple-carousel__arrow--right {
    margin-right: -50px;
}

.slick-slider {
    /* margin-left: 25px;
    margin-right: 25px; */
    font-size: 15px;
    text-align: center;
}
.slick-list {
    margin-left: 1rem!important;
    margin-right: 1rem!important;
}
.ket-widget {
    background-color: white;
    min-height: 17.5rem;
    border-radius: 0.3rem;
    padding: 0px!important;
}
.widget-header {
    color: white;
    display: block;
    text-align: center;
    font-weight: bold;
    min-height: 1.5rem;
    margin-left: 0px!important;
    border-top-left-radius: 0.3rem;
    border-top-right-radius: 0.3rem;

    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}
.large-widget-header {
    color: white;
    display: block;
    text-align: center;
    font-weight: bold;
    min-height: 1.5rem;
    margin-left: 0px!important;
    border-top-left-radius: 0.3rem;
    border-top-right-radius: 0.3rem;

}

.widget-header-toyota {
    background-color: rgb(229, 0, 0);
}
.widget-header-lexus {
    background-color: rgb(101, 101, 101);
}
.filter-button {
    border: none;
    color: white;
    text-align: center;
    margin: 0px;
    cursor: pointer;
    border-radius: 1rem;
    height: 1.8rem;
    padding-top: 0.5rem;
    padding-bottom: 1.5rem;
    padding-left: 2rem;
    padding-right: 2rem;
    font-weight: bold;
}
.filter-button-toyota {
    background-color: rgb(229, 0, 0);
    padding-top: 0.2rem;
}
.filter-button-lexus {
    background-color: rgb(101, 101, 101);
    padding-top: 0.2rem;
}
.scrollable-widget-content {
    min-height: 6.5rem;
    
}
.best-practice-board{
    min-height: 5.5rem !important;
    

}
.large-widget-content {
    min-height: 44.5rem;
    overflow-y: auto;
    max-height: 52rem;
    overflow-x: hidden;
}

.medium-widget-content {
    min-height: 15.5rem;
    overflow-y: auto;
    max-height: 16rem;
    overflow-x: hidden;
    width: 100%;
}
._loading_overlay_overlay {
    background: rgba(0, 0, 0, 0.33);
}
._loading_overlay_content {
    font-size: 15px;
}
._loading_overlay_spinner {
    width: 40px;
}
.downArrow{
    font-size: xx-large;

}
.upArrow{
    font-size: xx-large;
}
.activation {
padding: .4rem;
}

.text-alignment {
    text-align: right;
}

.activeRetailers {
    padding: .4rem;
    }
.countClass{
    min-height: 2.1rem;
}  
.programClass{
    min-height: 1.8rem;

}  
.filterClass{
    min-height: 1.8rem;
}
.widget_filter {
    max-height: 1.5rem;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    display: block;
   /*  padding-left: 8px !important;
    width: 164px; */
}
.widget_filter_arrow {
    position: absolute;
    display: block!important;
    margin-left: 0.2rem;
    margin-top: -0.2rem;
    cursor: pointer;
    color: black!important;
    
}
.widget_filter_arrow_disable {
    position: absolute;
    display: block!important;
    margin-left: 0.2rem;
    margin-top: -0.2rem;
    color:  rgb(101, 101, 101)!important;
    cursor: not-allowed;
    
}
.widget_filter_arrow_toyota {
    color: rgb(229, 0, 0);
}
.widget_filter_arrow_lexus {
    color: rgb(101, 101, 101);
}
.nextBtnClass {
    margin-right: 1.2rem;
    margin-top: -1.2rem;
    /* margin-right: 1.2rem;
    margin-top: -1.35rem; */
    float: right;
    font-size: large;
}
.previousBtnClass {
   
    margin-right: 1.2rem;
    margin-top: 0.5rem;
    float: left;
    font-size: large;
}
.widget_slider_class{
    padding-left: 0rem !important;
    padding-right: 0rem !important;
}
.widget_count_class {
    font-size: 35px;
    text-align: center;
    font-weight: bold;
    /* padding-top: 0.5rem; */
}

.widget_noticeBoard {
        font-size: 13.5px;
        text-align: left;
        /* font-weight: bold; */
        padding-top: 4px;
    }
.widget_arrow_class {
    padding-top: 0.5rem;
    font-size: 3rem;
    float: right;
}
.widget_brand_count {
    font-size: 1rem;
    font-weight: bold;
    text-align: center;
}
.widget_brand_count_section {
    text-align: center;
    border-top: 1px solid lightgray;
    margin-top: 3px!important;
    max-height: 1.5rem;
    padding-top: 3px!important;
}
.dashboard-search-filter > div > button{
    min-width: 12rem;
    padding-top: 2px;
    padding-bottom: 2px;
    height: 29px;
}
.dashboard-search-filter > div > div{
    /* max-width: 15.5rem; */
}
.dashboard-search-filter > div > div > div > div > div{
    overflow-x: hidden!important;
}
.small-font {
    font-size: 0.7rem;
    font-family: Arial, Helvetica, sans-serif;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding-right: 0px!important;
}
.left-border {
    border-left: 1px solid grey;
    padding-left: 5px!important;
    font-weight: bold;
}
.bottom-border {
    border-bottom: 1px solid grey;
}
.report-bottom-border {
    border-bottom: 0.8px solid #dee2e6;
}
.toolbox-name-toyota {
    font-weight: bold;
    color: rgb(229, 0, 0);
    /*white-space: initial!important;*/
}
.toolbox-name-lexus {
    font-weight: bold;
    color: rgb(101, 101, 101);
    /*white-space: initial!important;*/
}
.green-indicator {
    margin-left: 5px;
    color: #1dbd1d;
    font-size: 7px!important;
}
.toolbox-progress-bar {
    height: 1rem!important;
    margin-top: 1rem;
    background-color: #e50000 !important;
}
.toolbox-progress-bar > div {
    color: white!important;
    font-weight: 500;
}
.left-align-header {
    text-align: left!important;
    padding-left: 1rem;    
}

.widget-filter-icon {
    float: right;
    padding-right: 0.5rem;
    padding-top: 0.2rem;
    cursor: pointer;
}

.show widget-filter-icon-container{
    right:50px !important;
    position:absolute !important;
}

.widget-filter-icon-container {
    padding: 0px!important;
    display: inline!important;
    margin: 0px!important;
}

.widget-filter-icon-container > button{
    padding: 0px!important;
    background-color: transparent!important;
    box-shadow: none!important;
    float: right;
    font-size: 1rem;
    margin-top:1px!important;
}
.widget-table-header {
    font-size: 13.5px;
    font-weight: bold;
}
.rollout-widget-content {
    /* min-height: 1.5rem!important; */
    font-size: 13.5px !important;
    font-family: Arial, Helvetica, sans-serif;
}
.kpi-tree {
    font-size: 13.5px;
    height: 20rem;
    overflow-y: auto;
    /* font-weight: bold; */
    border: 1px solid lightgray;
    padding: 0px!important;
    width: 45%!important;
}
.tree-item {
    padding: 0.25rem 0.5rem;
    cursor: pointer;
    color: #333;
    background: none;
    border-bottom: 1px solid #ccc;
    box-shadow: none;
    z-index: auto;
    z-index: initial;
    position: relative; 
    width: 100%;
    text-align: left;
    border-top: none;
    border-left: none;
    border-right: none;
}
.tree-item-child {
    margin-left: 2rem;
    width: 90%;
    font-weight: 400;
}
.tree-item-child:focus {
    background: lightblue;
    font-weight: 400;
}
.selectedKpi{
    background: lightblue;
    /* outline: 1px dotted red; */
}
.kpi-modal-class {
    max-width: 60rem!important;
}
.trigger-button {
    font-size: 20px;
    font-weight: bold;
    height: 2rem;
    width: 2rem;
    border: 1px solid lightgray;
    color: gray;
    text-align: center;
    margin-left: 30%;
    cursor: pointer;
}
.pick-list-header-toyota {
    font-size: 13.5px;
    margin-bottom: 5px;
    margin-left: 10px;
    color: rgb(229, 0, 0);
    font-weight: bold;
}
.pick-list-header-lexus {
    font-size: 13.5px;
    margin-bottom: 5px;
    margin-left: 10px;
    color: rgb(101, 101, 101);
    font-weight: bold;
}
.trigger-button-toyota:hover {
    background-color: rgb(229, 0, 0);
}
.trigger-button-lexus:hover {
    background-color: rgb(101, 101, 101);
}
.tree-item-parent {
    font-weight: bold;
    font-size: 13.5px;
}
.tree-item-parent:before {
    content: "+"; 
    padding-right: 1rem;
    font-weight: bold;
    font-size: 13.5px;
}
.mandatory-kpi-icon {
    padding-left: 10px;
    object-fit: none;
    height: 15px;
}
.br-table-header {
    font-weight: bold;
    font-size: 14px;
    border-bottom: 1px solid gray;
}
.br-table-row {
    font-size: 13.5px!important;
    font-family: Arial, Helvetica, sans-serif!important;
}
.red-font {
    color: red!important;
    font-weight: bold;
    padding-Left: 2rem;
}
.green-font {
    color: green!important;
    font-weight: bold;
    padding-Left: 2rem;
}
.no-font{
    padding-Left: 2.5rem !important;
}
.br-select-table-header {
    font-size: 13.5px;
    font-weight: bold;
    border-bottom: 1px solid gray;
    margin-left: 2rem!important;
    margin-right: 0.5rem!important;
    display: flex!important;
}
.widget-filter-date-picker {
    /* font-size: 12px; */
    font-family: Arial;
    width: 150px;
    /* height: calc(1.5em + .75rem + 2px);; */
    height: 30px;
    border-radius: 5px;
    border: 1px solid #ced4da;
    padding-left: 3px;
    display: block;
    /* width: 100%; */
    padding: 0.375rem 0.75rem;
    font-size: 15px;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
}
.dashboardDiv .marginTopDashboad{
    margin: 5px;
}
.dropdown-item {
    padding: 0px!important
}
.widget-filter-dd-header {
    font-size: .81rem;
    white-space: normal;
    color: #595d60;
    font-family: Arial,sans-serif;
    padding-top: 3px;
}
.small-filter-button {
    /* width: 10px;
    padding-left: 2.5rem;
    padding-top: 0.3rem;
    padding-bottom: 2rem;
    font-size: 12px;
    margin-top: 5%;
    margin-left: 75%; */
    background-color: #e50000;
    /* Green */
    border: none;
    color: white;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    margin: 4px 2px;
    cursor: pointer;
    border-radius: 1.25rem;
    padding: 0.590rem 40px;
    height: 2.5rem;
}
.widget-filter-dd-menu {
    left: 100px!important;
    min-width: 15rem !important;
    transform: translate3d(-70px, 25px, 0px) !important;
}
.widget-filter-dd-menu-TME {
    left: 100px!important;
    min-width: 15rem !important;
    transform: translate3d(60px, 25px, 0px) !important;
}
.widgetTransform{
    transform: translate3d(-190px, -2px, 30px) !important;
    left:0px !important;
}
.text-ellipsis {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
.image{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: right;
    cursor: pointer;
}
.dashboard-search-filter .disabledNmsc > div,.dashboard-search-filter .disabledNmsc > div > div,.dashboard-search-filter .disabledNmsc > div > div > div{
    height: 29px;
    min-height: 29px;
}
.disabledNmsc .css-162g8z5{
    background-color: #FFF;


}
.dashboard-search-filter > div{
    width:12rem;
}
.scroll-widget-content {
    font-size: 13.5px !important;
    min-height: 8rem;
    overflow-y: auto;
    max-height: 10rem;
    overflow-x: hidden;
}
.text-style-Report {
    font-size: 13.5px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    /* font-weight: bold; */
}

/* .dealer dashboard css */
.dealer-dashboard-table {
    min-height: 38rem;
    /* max-height: 38rem; */
    background-color: white;
   

}

.dealer-scrollable-widgets {
    min-height: 8rem;
    max-height: 8rem;
    min-width: 12.5em;
}

.best-practice-table{
    min-height: 6.5rem !important;
   

}

.scoreLabels {
    color:black;
    margin-left: 48%;
    font-weight: 400;

}
.toolboxImplCss .dropdown-menu{
    min-width: 15rem;
    top: 27px !important;
    left: 300px !important;
}
.LegendCss{
    font-family: Arial, Helvetica, sans-serif;
    font-size: 13.5px;
    margin-top: 3px;
    padding-Left: 0.8rem; ;
}

.widget-header-report {
    color: white;
    display: block;
    text-align: left;
    font-weight: bold;
    min-height: 1.5rem;
    margin-left: 0px!important;
    border-top-left-radius: 0.3rem;
    border-top-right-radius: 0.3rem;
    padding-left: 5px;
}


.businessResult .dropdown-menu{
    left: 75px !important;
}

.widget-header_sub {
    display: block;
    text-align: center;
    min-height: 1.5rem;
    font-weight: 550;
    margin-left: 0px!important;
    border-top-left-radius: 0.3rem;
    border-top-right-radius: 0.3rem;
}

.actionItemReport tbody, .actionItemReport tr {
    display: block;
}

.actionItemReport tr:after {
    content: ' ';
    display: block;
    visibility: hidden;
    clear: both;
}

.actionItemReport tbody {
    height: 65vh;
    overflow-y: scroll;
}

.actionItemReport table {
    border-spacing: 3px 7px;
    border-collapse: separate;
    margin-bottom: 0px !important;
}

.actionItemReport tbody>tr>td {
    width: 7rem;
    float: left;
    text-overflow: ellipsis;
    overflow: hidden;
    color:black !important;
    font-family: Arial, Helvetica, sans-serif !important;
    font-weight:400;
}

.actionItemReport thead>tr>th {
    width: 7rem;
    float: left;
    font-family: Arial, Helvetica, sans-serif !important;
}

div.actionItemReport div.row.react-bootstrap-table-pagination div {
    padding: 0px !important;
}


.actionItemTable {
    padding: 1rem;
    min-height: 300px !important;
    background-color: #f0f0f0 !important;
    font-weight: bold;
}

.actionItemTable .react-bootstrap-table th[data-row-selection] {
          width: 110px;
}

.actionItem .widget-header-report {
    color: white;
    display: block;
    text-align: left;
    font-weight: bold;
    min-height: 2rem;
    margin-left: 0px !important;
    border-top-left-radius: 0.3rem;
    border-top-right-radius: 0.3rem;
    padding-left: 14px;
    padding-top: 0.2rem;
}

.best-practice-board  tbody tr {
    border-bottom: 1px solid #f0f0f0 !important;
}


.best-practice-board table.table th, .best-practice-board table.table td {
    padding:0px 0px; 
    color:#000000;
}
.best-practice-board{
    font-size: 15px;
    font-weight: bold;
    
}
.scrollable-Best-practice{
    /* min-height: 8.5rem; */
    /* overflow-y: auto; */
    /* max-height: 8.5rem; */
    /* overflow-x: hidden; */

}

#dealerKpi tbody {
    overflow-y: scroll;
    border: solid 1px #a8aaac;
    height: 30rem !important;
    display: block;
    width: 58rem;
}

#dealerKpi .table > tbody > tr {
    width: 100%;
    float: left;
}

#dealerKpi .table > tbody > tr > td {
    word-wrap: break-word;
    color:#000000;
}

#dealerKpi tbody tr td:first-child {
  width: 6rem !important;
 }


 #dealerKpi thead tr th:first-child {
    width: 6rem !important;
   }

 /* CSS for dashboard search */
 .lexus-FontWithBold {
    color: #252525;
    font-weight: bold;
    padding-left: 1rem !important;
    padding-top: 1.0rem;
    margin-top: 0.2rem;
}

.toyota-FontWithBold {
    color: #e50000;
    font-weight: bold;
    padding-left: 1rem !important;
    padding-top: 1.0rem;
    margin-top: 0.2rem;
}

.boldFont {
    font-weight: bold;
    padding-top: 1.0rem;
}

.toyota-hide-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    height: 19px;
    width: 19px;
    background-position: center;
    margin: 0 0.3rem;
}

.lexus-hide-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    height: 19px;
    width: 19px;
    background-position: center;
    margin: 0 0.3rem;
}

.searchDash {
    padding: 1rem;
    border-left: 6px solid;
    border-left-color: #e50000;
    border-right: 6px solid;
    border-right-color: #e50000;
    border-top: 1px solid;
    border-top-color: #000000;
    border-bottom: 1px solid;
    border-bottom-color: #000000;
}
.dashboardSearch{
    /* border-bottom-right-radius: 1.25rem;
    border-bottom-left-radius: 1.25rem; */
    border-top-right-radius: 1.25rem;
    border-top-left-radius: 1.25rem;
    background-color: #f0f0f0;
}

.bigDD-toyota .react-datepicker__close-icon::after {
    background-color: #e50000;
}

.bigDD-lexus .react-datepicker__close-icon::after {
    background-color: #252525;
}

.bigDD-toyota .css-1r4vtzz,.bigDD-toyota .css-1sontr1,.bigDD-lexus .css-1sontr1, .bigDD-toyota .css-48ayfv, .bigDD-lexus .css-1r4vtzz, .bigDD-lexus .css-48ayfv {
    width: 12.7rem;
}

.bigDD-toyota .css-1r4vtzz svg, .bigDD-toyota .css-48ayfv svg {
    color: #e50000 !important;
}

.bigDD-lexus .css-1r4vtzz svg, .bigDD-lexus .css-48ayfv svg {
    color: #252525 !important;
}

.searchDash .noPadding {
    padding: 0px;
}
.dealerDashboard{
    background-color: #f0f0f0;
    border-top-right-radius: 1.25rem;
    border-top-left-radius: 1.25rem;
    border-bottom-right-radius: 1.25rem;
    border-bottom-left-radius: 1.25rem;
}

#dealerKpi .table > tbody > tr > td.react-bs-table-no-data {
    width: 79rem !important;
} 

.large-widget-content .progress {
    height:2rem !important;
} 

.size.progress{
   height: 2.2rem !important;
}



.britVideoPlayer{
    margin: auto;
    margin-top: 29px;
}
.britDashboardTable{
    font-weight: 300;
    font-size: .81rem;
    
    max-width: 100%;
    background-color: #f0f0f0;
    border-top-right-radius: 1.25rem;
    border-top-left-radius: 1.25rem;
    border-bottom-right-radius: 1.25rem;
    border-bottom-left-radius: 1.25rem;
    margin-top: 1rem !important;
    position: relative;
    top: 25px;
    min-height: 33rem;
    margin-right: 1rem;
    margin-left: 1rem;
    overflow-y: auto;
}
.britVideoTable{
    margin-top: 0px;
    font-family: Arial,sans-serif;
    font-weight: bold;
    margin: 0.5rem 1rem 0.5rem 1rem
}

.britVideoTable tbody{
    /* height:76vh; */
    color: #595d60;
    font-family: Arial,sans-serif;

}
.britVideoLabel{
    border-bottom: 1px solid;
    border-bottom-color: #000000;
}

.backToBritVideoTable{
    position: absolute;
    bottom: 0rem;
}
.hideIcon1 {
    display: none;
}
.controlledIcon1{
    display: block !important;
}
/* start by beauty */
.certificate-toyota{
    overflow: visible !important;
    background-color: rgb(229, 0, 0);
    color: white;
    display: block;
    text-align: center;
    font-weight: bold;
    min-height: 1.5rem;
    margin-left: 0px !important;
    border-top-left-radius: 0.3rem;
    border-top-right-radius: 0.3rem;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size:14px !important;
}

.react-multi-carousel-list {
    /* overflow: visible !important; */
    z-index: 1 !important;
}
.dashboardDiv{
    /* overflow: hidden !important; */
    z-index: 999999999 !important;
}
.react-datepicker__navigation--next {
    right: 3em !important;
}
.react-datepicker__navigation--previous {
    left: 3em !important;
}

.react-datepicker-popper[data-placement^="bottom"] {
    margin-left: -30px;
    z-index: 9;
}
.toolboxImplCss .dropdown-menu {
    min-width: 15rem;
    top: 27px !important;
    left: 300px !important;
}
/* .react-datepicker-popper[data-placement^="top"] {
    margin-left: -30px;
} */
li.react-multi-carousel-item.react-multi-carousel-item--active.carousel-item-padding-40-px {
    width:176px !important;
}

/** Date slicer component css (NAS) - Starts from here*/
.date-range-container {
    width: 28%;
    margin: 0 auto;
  }

  .date-slider {
    position: relative;
    height: 40px;
    margin-top: 20px;
  }
  
  .date-track {
    position: absolute;
    top: 18px;
    height: 4px;
    background: #ddd;
    width: 100%;
    border-radius: 2px;
  }
  
  .date-range {
    position: absolute;
    top: 18px;
    height: 4px;
    background: #495057;
    border-radius: 2px;
  }
  
  .date-thumb {
    position: absolute;
    top: 10px;
    width: 16px;
    height: 16px;
    background: rgb(229, 0, 0);
    border-radius: 50%;
    cursor: pointer;
    transform: translateX(-50%);
    z-index: 3;
  }
  
  .date-start-thumb {
    z-index: 4;
  }
  
  /** Date slicer component css (NAS) - Ends here*/

  .disabledNmscCss {
    width: 15%;
    padding-right: 20px;
  }

  .ket-widget-custom-css{
    height: 550px !important;
  }

  span.react-bootstrap-table-sort-order.dropup {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    width: 16px;
    height: 20px;
    float: left;
    background-position: center;
    position: absolute;
    background-size: 80px 60px;
    visibility: hidden;
}

span.react-bootstrap-table-sort-order {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    width: 16px;
    height: 20px;
    float: left;
    position: absolute;
    background-position: center;
    background-size: 80px 60px;
    visibility: hidden;
}

.filter-button-NAS {
    border: none;
    color: white;
    text-align: center;
    margin: 0px;
    cursor: pointer;
    border-radius: 1rem;
    height: 1.8rem;
    padding-top: 0.2rem;
    padding-bottom: 1.5rem;
    padding-left: 2rem;
    padding-right: 2rem;
    font-weight: bold;
}

.toolboxImplNasCss{
    top: 27px !important;
    left: 300px !important;
}

.widget-filter-menu {
    left: 100px!important;
    transform: translate3d(-70px, 25px, 0px) !important;
}
.widget-filter-menu-TME {
    left: 100px!important;
    transform: translate3d(60px, 25px, 0px) !important;
}

.widget-filter-menu-score {
    transform: translate3d(24px, 20px, 0px) !important;
}

.widget-filter-menu-score-per-nmsc {
    transform: translate3d(90px, 20px, 0px) !important;
}

.widget-filter-menu-kaizen-overview {
    transform: translate3d(127px, 20px, 0px) !important;
}

/** For 67%  */
@media screen and (max-width: 2037px) and (min-width: 2030px) {
    .date-range-container {
        width: 24.5%;
        margin: 0 auto;
      }
}
/** For 75%  */
@media screen and (max-width: 1850px) and (min-width: 1810px) {
    .date-range-container {
        width: 25.5%;
        margin: 0 auto;
      }
}

/** For 80%  */
@media screen and (max-width: 1700px) and (min-width: 1697px) {
    .date-range-container {
        width: 26%;
        margin: 0 auto;
      }
}

/** For 90%  */
@media screen and (max-width: 1600px) and (min-width: 1508px) {
    .date-range-container {
        width: 27.5%;
        margin: 0 auto;
      }
}

/** For 100% */
@media screen and (max-width: 1358px) and (min-width: 1300px) {
    .date-range-container {
        width: 28.5%;
        margin: 0 auto;
      }
}

/** For 110% */
@media screen and (max-width: 1235px) and (min-width: 1200px) {
    .date-range-container {
        width: 29.5%;
        margin: 0 auto;
      }
}
/** For 125% */
@media screen and (max-width: 1100px) and (min-width: 1086px) {
    .date-range-container {
        width: 28%;
        margin: 0 auto;
      }
}

/** For 150% */
@media screen and (max-width: 1000px) and (min-width: 905px) {
    .date-range-container {
        width: 28.5%;
        margin: 0 auto;
      }
}

/** For NAS dealer */
.actionItemTableNAS {
    padding: 1rem;
    height: 50px !important;
    background-color: #f0f0f0 !important;
    font-weight: bold;
}

.actionItemTableNAS .react-bootstrap-table th[data-row-selection] {
     width: 6.875rem;
    }

.actionItemTableNAS .react-bootstrap-table tbody {
     height: 11rem !important;
    }
    
/* Table header stick  */
/* Sticky Header Styles for Score Table */
.sticky-header-table .table thead th {
    position: sticky !important;
    top: -10 !important;
    background-color: #f8f9fa !important;
    z-index: 100 !important;
    border-bottom: 2px solid #dee2e6 !important;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1) !important;
}

.sticky-header-table .table {
    margin-bottom: 0 !important;
}

.sticky-header-table {
    width: 100% !important;
    position: relative !important;
}

.sticky-table-header {
    position: sticky !important;
    top: 0 !important;
    background-color: white !important;
    z-index: 100 !important;
}

/* Ensure proper scrolling behavior */
.sticky-header-table .table-responsive {
    overflow-y: auto !important;
    max-height: 100% !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/dashboard/index.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,wBAAwB;AAC5B;AACA;IACI,oCAAoC;IACpC,aAAa;IACb,mCAAmC;IACnC,kCAAkC;;;AAGtC;AACA;IACI,mBAAmB;;AAEvB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI;yBACqB;IACrB,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,2BAA2B;IAC3B,4BAA4B;AAChC;AACA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;IACrB,sBAAsB;AAC1B;AACA;IACI,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,0BAA0B;IAC1B,8BAA8B;IAC9B,+BAA+B;;IAE/B,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,0BAA0B;IAC1B,8BAA8B;IAC9B,+BAA+B;;AAEnC;;AAEA;IACI,gCAAgC;AACpC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,gCAAgC;IAChC,mBAAmB;AACvB;AACA;IACI,oCAAoC;IACpC,mBAAmB;AACvB;AACA;IACI,kBAAkB;;AAEtB;AACA;IACI,6BAA6B;;;AAGjC;AACA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,+BAA+B;AACnC;AACA;IACI,eAAe;AACnB;AACA;IACI,WAAW;AACf;AACA;IACI,mBAAmB;;AAEvB;AACA;IACI,mBAAmB;AACvB;AACA;AACA,cAAc;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd;AACJ;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;;AAEtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;GACf;mBACgB;AACnB;AACA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,sBAAsB;;AAE1B;AACA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,mBAAmB;IACnB,mBAAmB;IACnB,oCAAoC;IACpC,mBAAmB;;AAEvB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,oBAAoB;IACpB,mBAAmB;IACnB;2BACuB;IACvB,YAAY;IACZ,gBAAgB;AACpB;AACA;;IAEI,oBAAoB;IACpB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,6BAA6B;IAC7B,8BAA8B;AAClC;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;QACQ,iBAAiB;QACjB,gBAAgB;QAChB,uBAAuB;QACvB,gBAAgB;IACpB;AACJ;IACI,mBAAmB;IACnB,eAAe;IACf,YAAY;AAChB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,+BAA+B;IAC/B,yBAAyB;IACzB,kBAAkB;IAClB,0BAA0B;AAC9B;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;AAChB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,4BAA4B;AAChC;AACA;IACI,iBAAiB;IACjB,yCAAyC;IACzC,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,4BAA4B;AAChC;AACA;IACI,2BAA2B;IAC3B,2BAA2B;IAC3B,iBAAiB;AACrB;AACA;IACI,6BAA6B;AACjC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,kCAAkC;AACtC;AACA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kCAAkC;AACtC;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,wBAAwB;AAC5B;AACA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,oCAAoC;AACxC;AACA;IACI,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,4BAA4B;AAChC;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,uCAAuC;IACvC,0BAA0B;IAC1B,YAAY;IACZ,eAAe;IACf,wBAAwB;AAC5B;AACA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,kCAAkC;IAClC,4BAA4B;IAC5B,yCAAyC;AAC7C;AACA;IACI,iBAAiB;IACjB,aAAa;IACb,gBAAgB;IAChB,uBAAuB;IACvB,2BAA2B;IAC3B,sBAAsB;IACtB,oBAAoB;AACxB;AACA;IACI,uBAAuB;IACvB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,6BAA6B;IAC7B,gBAAgB;IAChB,aAAc;IAAd,gBAAc;IACd,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,UAAU;IACV,gBAAgB;AACpB;AACA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;AACA;IACI,qBAAqB;IACrB,6BAA6B;AACjC;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,qBAAqB;IACrB,iBAAiB;AACrB;AACA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,iBAAiB;AACrB;AACA;IACI,gCAAgC;AACpC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,6BAA6B;AACjC;AACA;IACI,2BAA2B;IAC3B,mDAAmD;AACvD;AACA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,+BAA+B;AACnC;AACA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,6BAA6B;IAC7B,2BAA2B;IAC3B,8BAA8B;IAC9B,uBAAuB;AAC3B;AACA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;IACZ,yCAAyC;IACzC,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,4BAA4B;IAC5B,yBAAyB;AAC7B;AACA;IACI,WAAW;AACf;AACA;IACI;AACJ;AACA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,6BAA6B;IAC7B,gBAAgB;AACpB;AACA;IACI;;;;;;uBAMmB;IACnB,yBAAyB;IACzB,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,eAAe;IACf,eAAe;IACf,sBAAsB;IACtB,sBAAsB;IACtB,cAAc;AAClB;AACA;IACI,qBAAqB;IACrB,2BAA2B;IAC3B,mDAAmD;AACvD;AACA;IACI,qBAAqB;IACrB,2BAA2B;IAC3B,kDAAkD;AACtD;AACA;IACI,qDAAqD;IACrD,mBAAmB;AACvB;AACA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,yDAA0D;IAC1D,4BAA4B;IAC5B,0BAA0B;IAC1B,eAAe;AACnB;AACA;IACI,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,sBAAsB;;;AAG1B;AACA;IACI,WAAW;AACf;AACA;IACI,4BAA4B;IAC5B,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA,0BAA0B;AAC1B;IACI,iBAAiB;IACjB,uBAAuB;IACvB,uBAAuB;;;AAG3B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,6BAA6B;;;AAGjC;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,gBAAgB;;AAEpB;AACA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;AAC1B;AACA;IACI,yCAAyC;IACzC,iBAAiB;IACjB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,0BAA0B;IAC1B,8BAA8B;IAC9B,+BAA+B;IAC/B,iBAAiB;AACrB;;;AAGA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B,8BAA8B;IAC9B,+BAA+B;AACnC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,WAAW;IACX,uBAAuB;IACvB,gBAAgB;IAChB,sBAAsB;IACtB,oDAAoD;IACpD,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,oDAAoD;AACxD;;AAEA;IACI,uBAAuB;AAC3B;;;AAGA;IACI,aAAa;IACb,4BAA4B;IAC5B,oCAAoC;IACpC,iBAAiB;AACrB;;AAEA;UACU,YAAY;AACtB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,2BAA2B;IAC3B,8BAA8B;IAC9B,+BAA+B;IAC/B,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,2CAA2C;AAC/C;;;AAGA;IACI,eAAe;IACf,aAAa;AACjB;AACA;IACI,eAAe;IACf,iBAAiB;;AAErB;AACA;IACI,wBAAwB;IACxB,sBAAsB;IACtB,wBAAwB;IACxB,wBAAwB;;AAE5B;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,wBAAwB;IACxB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,aAAa;AACjB;;AAEA;EACE,sBAAsB;CACvB;;;CAGA;IACG,sBAAsB;GACvB;;CAEF,6BAA6B;CAC7B;IACG,cAAc;IACd,iBAAiB;IACjB,6BAA6B;IAC7B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,6BAA6B;IAC7B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,yDAA6D;IAC7D,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,yDAA4D;IAC5D,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B;IAC3B,qBAAqB;IACrB,yBAAyB;IACzB,wBAAwB;IACxB,4BAA4B;AAChC;AACA;IACI;yCACqC;IACrC,gCAAgC;IAChC,+BAA+B;IAC/B,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;AACA;IACI,yBAAyB;IACzB,gCAAgC;IAChC,+BAA+B;IAC/B,mCAAmC;IACnC,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;GACG,yBAAyB;AAC5B;;;;AAIA;IACI,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,iBAAiB;;IAEjB,eAAe;IACf,yBAAyB;IACzB,gCAAgC;IAChC,+BAA+B;IAC/B,mCAAmC;IACnC,kCAAkC;IAClC,2BAA2B;IAC3B,kBAAkB;IAClB,SAAS;IACT,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,6BAA6B;IAC7B,iBAAiB;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,6BAA6B;;AAEjC;AACA;IACI,wBAAwB;IACxB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,aAAa;AACjB;AACA;IACI,yBAAyB;AAC7B;AACA,oBAAoB;AACpB;IACI,4BAA4B;IAC5B,gCAAgC;IAChC,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,2BAA2B;IAC3B,8BAA8B;IAC9B,+BAA+B;IAE/B,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;IAClC,qBAAqB;AACzB;AACA;IACI,iCAAiC;IACjC,6BAA6B;AACjC;AACA;IACI,qBAAqB;AACzB;AACA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;AAC1B;AACA;;GAEG;AACH;IACI,sBAAsB;AAC1B;;AAEA,uDAAuD;AACvD;IACI,UAAU;IACV,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,kBAAkB;IAClB,eAAe;IACf,2BAA2B;IAC3B,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA,gDAAgD;;EAEhD;IACE,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,yDAAgE;IAChE,WAAW;IACX,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,kBAAkB;IAClB,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,yDAA8D;IAC9D,WAAW;IACX,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,2BAA2B;IAC3B,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,mDAAmD;AACvD;AACA;IACI,qBAAqB;IACrB,kDAAkD;AACtD;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,mDAAmD;AACvD;;AAEA,cAAc;AACd;IACI;QACI,YAAY;QACZ,cAAc;MAChB;AACN;AACA,cAAc;AACd;IACI;QACI,YAAY;QACZ,cAAc;MAChB;AACN;;AAEA,cAAc;AACd;IACI;QACI,UAAU;QACV,cAAc;MAChB;AACN;;AAEA,cAAc;AACd;IACI;QACI,YAAY;QACZ,cAAc;MAChB;AACN;;AAEA,cAAc;AACd;IACI;QACI,YAAY;QACZ,cAAc;MAChB;AACN;;AAEA,cAAc;AACd;IACI;QACI,YAAY;QACZ,cAAc;MAChB;AACN;AACA,cAAc;AACd;IACI;QACI,UAAU;QACV,cAAc;MAChB;AACN;;AAEA,cAAc;AACd;IACI;QACI,YAAY;QACZ,cAAc;MAChB;AACN;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,uBAAuB;IACvB,oCAAoC;IACpC,iBAAiB;AACrB;;AAEA;KACK,eAAe;IAChB;;AAEJ;KACK,wBAAwB;IACzB;;AAEJ,wBAAwB;AACxB,yCAAyC;AACzC;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,oCAAoC;IACpC,uBAAuB;IACvB,2CAA2C;IAC3C,gDAAgD;AACpD;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;IAC3B,iBAAiB;IACjB,kCAAkC;IAClC,uBAAuB;AAC3B;;AAEA,qCAAqC;AACrC;IACI,2BAA2B;IAC3B,2BAA2B;AAC/B","sourcesContent":[".scrollable-widgets {\n    min-height: 8rem;\n    max-height: 8rem;\n    min-width: 10.5rem;\n    /* max-width: 10.5rem; */\n}\n.dashboardDiv{\n    background-color: #f0f0f0 !important;\n    padding: 1rem;\n    border-bottom-right-radius: 1.25rem;\n    border-bottom-left-radius: 1.25rem;\n\n\n}\n.dashboardDiv .react-multi-carousel-item{\n    padding-right: 1rem;\n\n}\n.react-multiple-carousel__arrow--left {\n    margin-left: -50px;\n}\n.react-multiple-carousel__arrow--right {\n    margin-right: -50px;\n}\n\n.slick-slider {\n    /* margin-left: 25px;\n    margin-right: 25px; */\n    font-size: 15px;\n    text-align: center;\n}\n.slick-list {\n    margin-left: 1rem!important;\n    margin-right: 1rem!important;\n}\n.ket-widget {\n    background-color: white;\n    min-height: 17.5rem;\n    border-radius: 0.3rem;\n    padding: 0px!important;\n}\n.widget-header {\n    color: white;\n    display: block;\n    text-align: center;\n    font-weight: bold;\n    min-height: 1.5rem;\n    margin-left: 0px!important;\n    border-top-left-radius: 0.3rem;\n    border-top-right-radius: 0.3rem;\n\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n}\n.large-widget-header {\n    color: white;\n    display: block;\n    text-align: center;\n    font-weight: bold;\n    min-height: 1.5rem;\n    margin-left: 0px!important;\n    border-top-left-radius: 0.3rem;\n    border-top-right-radius: 0.3rem;\n\n}\n\n.widget-header-toyota {\n    background-color: rgb(229, 0, 0);\n}\n.widget-header-lexus {\n    background-color: rgb(101, 101, 101);\n}\n.filter-button {\n    border: none;\n    color: white;\n    text-align: center;\n    margin: 0px;\n    cursor: pointer;\n    border-radius: 1rem;\n    height: 1.8rem;\n    padding-top: 0.5rem;\n    padding-bottom: 1.5rem;\n    padding-left: 2rem;\n    padding-right: 2rem;\n    font-weight: bold;\n}\n.filter-button-toyota {\n    background-color: rgb(229, 0, 0);\n    padding-top: 0.2rem;\n}\n.filter-button-lexus {\n    background-color: rgb(101, 101, 101);\n    padding-top: 0.2rem;\n}\n.scrollable-widget-content {\n    min-height: 6.5rem;\n    \n}\n.best-practice-board{\n    min-height: 5.5rem !important;\n    \n\n}\n.large-widget-content {\n    min-height: 44.5rem;\n    overflow-y: auto;\n    max-height: 52rem;\n    overflow-x: hidden;\n}\n\n.medium-widget-content {\n    min-height: 15.5rem;\n    overflow-y: auto;\n    max-height: 16rem;\n    overflow-x: hidden;\n    width: 100%;\n}\n._loading_overlay_overlay {\n    background: rgba(0, 0, 0, 0.33);\n}\n._loading_overlay_content {\n    font-size: 15px;\n}\n._loading_overlay_spinner {\n    width: 40px;\n}\n.downArrow{\n    font-size: xx-large;\n\n}\n.upArrow{\n    font-size: xx-large;\n}\n.activation {\npadding: .4rem;\n}\n\n.text-alignment {\n    text-align: right;\n}\n\n.activeRetailers {\n    padding: .4rem;\n    }\n.countClass{\n    min-height: 2.1rem;\n}  \n.programClass{\n    min-height: 1.8rem;\n\n}  \n.filterClass{\n    min-height: 1.8rem;\n}\n.widget_filter {\n    max-height: 1.5rem;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n    display: block;\n   /*  padding-left: 8px !important;\n    width: 164px; */\n}\n.widget_filter_arrow {\n    position: absolute;\n    display: block!important;\n    margin-left: 0.2rem;\n    margin-top: -0.2rem;\n    cursor: pointer;\n    color: black!important;\n    \n}\n.widget_filter_arrow_disable {\n    position: absolute;\n    display: block!important;\n    margin-left: 0.2rem;\n    margin-top: -0.2rem;\n    color:  rgb(101, 101, 101)!important;\n    cursor: not-allowed;\n    \n}\n.widget_filter_arrow_toyota {\n    color: rgb(229, 0, 0);\n}\n.widget_filter_arrow_lexus {\n    color: rgb(101, 101, 101);\n}\n.nextBtnClass {\n    margin-right: 1.2rem;\n    margin-top: -1.2rem;\n    /* margin-right: 1.2rem;\n    margin-top: -1.35rem; */\n    float: right;\n    font-size: large;\n}\n.previousBtnClass {\n   \n    margin-right: 1.2rem;\n    margin-top: 0.5rem;\n    float: left;\n    font-size: large;\n}\n.widget_slider_class{\n    padding-left: 0rem !important;\n    padding-right: 0rem !important;\n}\n.widget_count_class {\n    font-size: 35px;\n    text-align: center;\n    font-weight: bold;\n    /* padding-top: 0.5rem; */\n}\n\n.widget_noticeBoard {\n        font-size: 13.5px;\n        text-align: left;\n        /* font-weight: bold; */\n        padding-top: 4px;\n    }\n.widget_arrow_class {\n    padding-top: 0.5rem;\n    font-size: 3rem;\n    float: right;\n}\n.widget_brand_count {\n    font-size: 1rem;\n    font-weight: bold;\n    text-align: center;\n}\n.widget_brand_count_section {\n    text-align: center;\n    border-top: 1px solid lightgray;\n    margin-top: 3px!important;\n    max-height: 1.5rem;\n    padding-top: 3px!important;\n}\n.dashboard-search-filter > div > button{\n    min-width: 12rem;\n    padding-top: 2px;\n    padding-bottom: 2px;\n    height: 29px;\n}\n.dashboard-search-filter > div > div{\n    /* max-width: 15.5rem; */\n}\n.dashboard-search-filter > div > div > div > div > div{\n    overflow-x: hidden!important;\n}\n.small-font {\n    font-size: 0.7rem;\n    font-family: Arial, Helvetica, sans-serif;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    padding-right: 0px!important;\n}\n.left-border {\n    border-left: 1px solid grey;\n    padding-left: 5px!important;\n    font-weight: bold;\n}\n.bottom-border {\n    border-bottom: 1px solid grey;\n}\n.report-bottom-border {\n    border-bottom: 0.8px solid #dee2e6;\n}\n.toolbox-name-toyota {\n    font-weight: bold;\n    color: rgb(229, 0, 0);\n    /*white-space: initial!important;*/\n}\n.toolbox-name-lexus {\n    font-weight: bold;\n    color: rgb(101, 101, 101);\n    /*white-space: initial!important;*/\n}\n.green-indicator {\n    margin-left: 5px;\n    color: #1dbd1d;\n    font-size: 7px!important;\n}\n.toolbox-progress-bar {\n    height: 1rem!important;\n    margin-top: 1rem;\n    background-color: #e50000 !important;\n}\n.toolbox-progress-bar > div {\n    color: white!important;\n    font-weight: 500;\n}\n.left-align-header {\n    text-align: left!important;\n    padding-left: 1rem;    \n}\n\n.widget-filter-icon {\n    float: right;\n    padding-right: 0.5rem;\n    padding-top: 0.2rem;\n    cursor: pointer;\n}\n\n.show widget-filter-icon-container{\n    right:50px !important;\n    position:absolute !important;\n}\n\n.widget-filter-icon-container {\n    padding: 0px!important;\n    display: inline!important;\n    margin: 0px!important;\n}\n\n.widget-filter-icon-container > button{\n    padding: 0px!important;\n    background-color: transparent!important;\n    box-shadow: none!important;\n    float: right;\n    font-size: 1rem;\n    margin-top:1px!important;\n}\n.widget-table-header {\n    font-size: 13.5px;\n    font-weight: bold;\n}\n.rollout-widget-content {\n    /* min-height: 1.5rem!important; */\n    font-size: 13.5px !important;\n    font-family: Arial, Helvetica, sans-serif;\n}\n.kpi-tree {\n    font-size: 13.5px;\n    height: 20rem;\n    overflow-y: auto;\n    /* font-weight: bold; */\n    border: 1px solid lightgray;\n    padding: 0px!important;\n    width: 45%!important;\n}\n.tree-item {\n    padding: 0.25rem 0.5rem;\n    cursor: pointer;\n    color: #333;\n    background: none;\n    border-bottom: 1px solid #ccc;\n    box-shadow: none;\n    z-index: unset;\n    position: relative; \n    width: 100%;\n    text-align: left;\n    border-top: none;\n    border-left: none;\n    border-right: none;\n}\n.tree-item-child {\n    margin-left: 2rem;\n    width: 90%;\n    font-weight: 400;\n}\n.tree-item-child:focus {\n    background: lightblue;\n    font-weight: 400;\n}\n.selectedKpi{\n    background: lightblue;\n    /* outline: 1px dotted red; */\n}\n.kpi-modal-class {\n    max-width: 60rem!important;\n}\n.trigger-button {\n    font-size: 20px;\n    font-weight: bold;\n    height: 2rem;\n    width: 2rem;\n    border: 1px solid lightgray;\n    color: gray;\n    text-align: center;\n    margin-left: 30%;\n    cursor: pointer;\n}\n.pick-list-header-toyota {\n    font-size: 13.5px;\n    margin-bottom: 5px;\n    margin-left: 10px;\n    color: rgb(229, 0, 0);\n    font-weight: bold;\n}\n.pick-list-header-lexus {\n    font-size: 13.5px;\n    margin-bottom: 5px;\n    margin-left: 10px;\n    color: rgb(101, 101, 101);\n    font-weight: bold;\n}\n.trigger-button-toyota:hover {\n    background-color: rgb(229, 0, 0);\n}\n.trigger-button-lexus:hover {\n    background-color: rgb(101, 101, 101);\n}\n.tree-item-parent {\n    font-weight: bold;\n    font-size: 13.5px;\n}\n.tree-item-parent:before {\n    content: \"+\"; \n    padding-right: 1rem;\n    font-weight: bold;\n    font-size: 13.5px;\n}\n.mandatory-kpi-icon {\n    padding-left: 10px;\n    object-fit: none;\n    height: 15px;\n}\n.br-table-header {\n    font-weight: bold;\n    font-size: 14px;\n    border-bottom: 1px solid gray;\n}\n.br-table-row {\n    font-size: 13.5px!important;\n    font-family: Arial, Helvetica, sans-serif!important;\n}\n.red-font {\n    color: red!important;\n    font-weight: bold;\n    padding-Left: 2rem;\n}\n.green-font {\n    color: green!important;\n    font-weight: bold;\n    padding-Left: 2rem;\n}\n.no-font{\n    padding-Left: 2.5rem !important;\n}\n.br-select-table-header {\n    font-size: 13.5px;\n    font-weight: bold;\n    border-bottom: 1px solid gray;\n    margin-left: 2rem!important;\n    margin-right: 0.5rem!important;\n    display: flex!important;\n}\n.widget-filter-date-picker {\n    /* font-size: 12px; */\n    font-family: Arial;\n    width: 150px;\n    /* height: calc(1.5em + .75rem + 2px);; */\n    height: 30px;\n    border-radius: 5px;\n    border: 1px solid #ced4da;\n    padding-left: 3px;\n    display: block;\n    /* width: 100%; */\n    padding: 0.375rem 0.75rem;\n    font-size: 15px;\n    line-height: 1.5;\n    color: #495057;\n    background-color: #fff;\n    background-clip: padding-box;\n    border: 1px solid #ced4da;\n}\n.dashboardDiv .marginTopDashboad{\n    margin: 5px;\n}\n.dropdown-item {\n    padding: 0px!important\n}\n.widget-filter-dd-header {\n    font-size: .81rem;\n    white-space: normal;\n    color: #595d60;\n    font-family: Arial,sans-serif;\n    padding-top: 3px;\n}\n.small-filter-button {\n    /* width: 10px;\n    padding-left: 2.5rem;\n    padding-top: 0.3rem;\n    padding-bottom: 2rem;\n    font-size: 12px;\n    margin-top: 5%;\n    margin-left: 75%; */\n    background-color: #e50000;\n    /* Green */\n    border: none;\n    color: white;\n    text-align: center;\n    text-decoration: none;\n    display: inline-block;\n    margin: 4px 2px;\n    cursor: pointer;\n    border-radius: 1.25rem;\n    padding: 0.590rem 40px;\n    height: 2.5rem;\n}\n.widget-filter-dd-menu {\n    left: 100px!important;\n    min-width: 15rem !important;\n    transform: translate3d(-70px, 25px, 0px) !important;\n}\n.widget-filter-dd-menu-TME {\n    left: 100px!important;\n    min-width: 15rem !important;\n    transform: translate3d(60px, 25px, 0px) !important;\n}\n.widgetTransform{\n    transform: translate3d(-190px, -2px, 30px) !important;\n    left:0px !important;\n}\n.text-ellipsis {\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n}\n.image{\n    background-image: url(\"../../assets/images//calendar.png\");\n    background-repeat: no-repeat;\n    background-position: right;\n    cursor: pointer;\n}\n.dashboard-search-filter .disabledNmsc > div,.dashboard-search-filter .disabledNmsc > div > div,.dashboard-search-filter .disabledNmsc > div > div > div{\n    height: 29px;\n    min-height: 29px;\n}\n.disabledNmsc .css-162g8z5{\n    background-color: #FFF;\n\n\n}\n.dashboard-search-filter > div{\n    width:12rem;\n}\n.scroll-widget-content {\n    font-size: 13.5px !important;\n    min-height: 8rem;\n    overflow-y: auto;\n    max-height: 10rem;\n    overflow-x: hidden;\n}\n.text-style-Report {\n    font-size: 13.5px;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n    /* font-weight: bold; */\n}\n\n/* .dealer dashboard css */\n.dealer-dashboard-table {\n    min-height: 38rem;\n    /* max-height: 38rem; */\n    background-color: white;\n   \n\n}\n\n.dealer-scrollable-widgets {\n    min-height: 8rem;\n    max-height: 8rem;\n    min-width: 12.5em;\n}\n\n.best-practice-table{\n    min-height: 6.5rem !important;\n   \n\n}\n\n.scoreLabels {\n    color:black;\n    margin-left: 48%;\n    font-weight: 400;\n\n}\n.toolboxImplCss .dropdown-menu{\n    min-width: 15rem;\n    top: 27px !important;\n    left: 300px !important;\n}\n.LegendCss{\n    font-family: Arial, Helvetica, sans-serif;\n    font-size: 13.5px;\n    margin-top: 3px;\n    padding-Left: 0.8rem; ;\n}\n\n.widget-header-report {\n    color: white;\n    display: block;\n    text-align: left;\n    font-weight: bold;\n    min-height: 1.5rem;\n    margin-left: 0px!important;\n    border-top-left-radius: 0.3rem;\n    border-top-right-radius: 0.3rem;\n    padding-left: 5px;\n}\n\n\n.businessResult .dropdown-menu{\n    left: 75px !important;\n}\n\n.widget-header_sub {\n    display: block;\n    text-align: center;\n    min-height: 1.5rem;\n    font-weight: 550;\n    margin-left: 0px!important;\n    border-top-left-radius: 0.3rem;\n    border-top-right-radius: 0.3rem;\n}\n\n.actionItemReport tbody, .actionItemReport tr {\n    display: block;\n}\n\n.actionItemReport tr:after {\n    content: ' ';\n    display: block;\n    visibility: hidden;\n    clear: both;\n}\n\n.actionItemReport tbody {\n    height: 65vh;\n    overflow-y: scroll;\n}\n\n.actionItemReport table {\n    border-spacing: 3px 7px;\n    border-collapse: separate;\n    margin-bottom: 0px !important;\n}\n\n.actionItemReport tbody>tr>td {\n    width: 7rem;\n    float: left;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    color:black !important;\n    font-family: Arial, Helvetica, sans-serif !important;\n    font-weight:400;\n}\n\n.actionItemReport thead>tr>th {\n    width: 7rem;\n    float: left;\n    font-family: Arial, Helvetica, sans-serif !important;\n}\n\ndiv.actionItemReport div.row.react-bootstrap-table-pagination div {\n    padding: 0px !important;\n}\n\n\n.actionItemTable {\n    padding: 1rem;\n    min-height: 300px !important;\n    background-color: #f0f0f0 !important;\n    font-weight: bold;\n}\n\n.actionItemTable .react-bootstrap-table th[data-row-selection] {\n          width: 110px;\n}\n\n.actionItem .widget-header-report {\n    color: white;\n    display: block;\n    text-align: left;\n    font-weight: bold;\n    min-height: 2rem;\n    margin-left: 0px !important;\n    border-top-left-radius: 0.3rem;\n    border-top-right-radius: 0.3rem;\n    padding-left: 14px;\n    padding-top: 0.2rem;\n}\n\n.best-practice-board  tbody tr {\n    border-bottom: 1px solid #f0f0f0 !important;\n}\n\n\n.best-practice-board table.table th, .best-practice-board table.table td {\n    padding:0px 0px; \n    color:#000000;\n}\n.best-practice-board{\n    font-size: 15px;\n    font-weight: bold;\n    \n}\n.scrollable-Best-practice{\n    /* min-height: 8.5rem; */\n    /* overflow-y: auto; */\n    /* max-height: 8.5rem; */\n    /* overflow-x: hidden; */\n\n}\n\n#dealerKpi tbody {\n    overflow-y: scroll;\n    border: solid 1px #a8aaac;\n    height: 30rem !important;\n    display: block;\n    width: 58rem;\n}\n\n#dealerKpi .table > tbody > tr {\n    width: 100%;\n    float: left;\n}\n\n#dealerKpi .table > tbody > tr > td {\n    word-wrap: break-word;\n    color:#000000;\n}\n\n#dealerKpi tbody tr td:first-child {\n  width: 6rem !important;\n }\n\n\n #dealerKpi thead tr th:first-child {\n    width: 6rem !important;\n   }\n\n /* CSS for dashboard search */\n .lexus-FontWithBold {\n    color: #252525;\n    font-weight: bold;\n    padding-left: 1rem !important;\n    padding-top: 1.0rem;\n    margin-top: 0.2rem;\n}\n\n.toyota-FontWithBold {\n    color: #e50000;\n    font-weight: bold;\n    padding-left: 1rem !important;\n    padding-top: 1.0rem;\n    margin-top: 0.2rem;\n}\n\n.boldFont {\n    font-weight: bold;\n    padding-top: 1.0rem;\n}\n\n.toyota-hide-icon {\n    background-image: url(\"../../assets/images//hide-toyota.png\");\n    height: 19px;\n    width: 19px;\n    background-position: center;\n    margin: 0 0.3rem;\n}\n\n.lexus-hide-icon {\n    background-image: url(\"../../assets/images//hide-lexus.png\");\n    height: 19px;\n    width: 19px;\n    background-position: center;\n    margin: 0 0.3rem;\n}\n\n.searchDash {\n    padding: 1rem;\n    border-left: 6px solid;\n    border-left-color: #e50000;\n    border-right: 6px solid;\n    border-right-color: #e50000;\n    border-top: 1px solid;\n    border-top-color: #000000;\n    border-bottom: 1px solid;\n    border-bottom-color: #000000;\n}\n.dashboardSearch{\n    /* border-bottom-right-radius: 1.25rem;\n    border-bottom-left-radius: 1.25rem; */\n    border-top-right-radius: 1.25rem;\n    border-top-left-radius: 1.25rem;\n    background-color: #f0f0f0;\n}\n\n.bigDD-toyota .react-datepicker__close-icon::after {\n    background-color: #e50000;\n}\n\n.bigDD-lexus .react-datepicker__close-icon::after {\n    background-color: #252525;\n}\n\n.bigDD-toyota .css-1r4vtzz,.bigDD-toyota .css-1sontr1,.bigDD-lexus .css-1sontr1, .bigDD-toyota .css-48ayfv, .bigDD-lexus .css-1r4vtzz, .bigDD-lexus .css-48ayfv {\n    width: 12.7rem;\n}\n\n.bigDD-toyota .css-1r4vtzz svg, .bigDD-toyota .css-48ayfv svg {\n    color: #e50000 !important;\n}\n\n.bigDD-lexus .css-1r4vtzz svg, .bigDD-lexus .css-48ayfv svg {\n    color: #252525 !important;\n}\n\n.searchDash .noPadding {\n    padding: 0px;\n}\n.dealerDashboard{\n    background-color: #f0f0f0;\n    border-top-right-radius: 1.25rem;\n    border-top-left-radius: 1.25rem;\n    border-bottom-right-radius: 1.25rem;\n    border-bottom-left-radius: 1.25rem;\n}\n\n#dealerKpi .table > tbody > tr > td.react-bs-table-no-data {\n    width: 79rem !important;\n} \n\n.large-widget-content .progress {\n    height:2rem !important;\n} \n\n.size.progress{\n   height: 2.2rem !important;\n}\n\n\n\n.britVideoPlayer{\n    margin: auto;\n    margin-top: 29px;\n}\n.britDashboardTable{\n    font-weight: 300;\n    font-size: .81rem;\n    \n    max-width: 100%;\n    background-color: #f0f0f0;\n    border-top-right-radius: 1.25rem;\n    border-top-left-radius: 1.25rem;\n    border-bottom-right-radius: 1.25rem;\n    border-bottom-left-radius: 1.25rem;\n    margin-top: 1rem !important;\n    position: relative;\n    top: 25px;\n    min-height: 33rem;\n    margin-right: 1rem;\n    margin-left: 1rem;\n    overflow-y: auto;\n}\n.britVideoTable{\n    margin-top: 0px;\n    font-family: Arial,sans-serif;\n    font-weight: bold;\n    margin: 0.5rem 1rem 0.5rem 1rem\n}\n\n.britVideoTable tbody{\n    /* height:76vh; */\n    color: #595d60;\n    font-family: Arial,sans-serif;\n\n}\n.britVideoLabel{\n    border-bottom: 1px solid;\n    border-bottom-color: #000000;\n}\n\n.backToBritVideoTable{\n    position: absolute;\n    bottom: 0rem;\n}\n.hideIcon1 {\n    display: none;\n}\n.controlledIcon1{\n    display: block !important;\n}\n/* start by beauty */\n.certificate-toyota{\n    overflow: visible !important;\n    background-color: rgb(229, 0, 0);\n    color: white;\n    display: block;\n    text-align: center;\n    font-weight: bold;\n    min-height: 1.5rem;\n    margin-left: 0px !important;\n    border-top-left-radius: 0.3rem;\n    border-top-right-radius: 0.3rem;\n    -o-text-overflow: ellipsis;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    font-size:14px !important;\n}\n\n.react-multi-carousel-list {\n    /* overflow: visible !important; */\n    z-index: 1 !important;\n}\n.dashboardDiv{\n    /* overflow: hidden !important; */\n    z-index: 999999999 !important;\n}\n.react-datepicker__navigation--next {\n    right: 3em !important;\n}\n.react-datepicker__navigation--previous {\n    left: 3em !important;\n}\n\n.react-datepicker-popper[data-placement^=\"bottom\"] {\n    margin-left: -30px;\n    z-index: 9;\n}\n.toolboxImplCss .dropdown-menu {\n    min-width: 15rem;\n    top: 27px !important;\n    left: 300px !important;\n}\n/* .react-datepicker-popper[data-placement^=\"top\"] {\n    margin-left: -30px;\n} */\nli.react-multi-carousel-item.react-multi-carousel-item--active.carousel-item-padding-40-px {\n    width:176px !important;\n}\n\n/** Date slicer component css (NAS) - Starts from here*/\n.date-range-container {\n    width: 28%;\n    margin: 0 auto;\n  }\n\n  .date-slider {\n    position: relative;\n    height: 40px;\n    margin-top: 20px;\n  }\n  \n  .date-track {\n    position: absolute;\n    top: 18px;\n    height: 4px;\n    background: #ddd;\n    width: 100%;\n    border-radius: 2px;\n  }\n  \n  .date-range {\n    position: absolute;\n    top: 18px;\n    height: 4px;\n    background: #495057;\n    border-radius: 2px;\n  }\n  \n  .date-thumb {\n    position: absolute;\n    top: 10px;\n    width: 16px;\n    height: 16px;\n    background: rgb(229, 0, 0);\n    border-radius: 50%;\n    cursor: pointer;\n    transform: translateX(-50%);\n    z-index: 3;\n  }\n  \n  .date-start-thumb {\n    z-index: 4;\n  }\n  \n  /** Date slicer component css (NAS) - Ends here*/\n\n  .disabledNmscCss {\n    width: 15%;\n    padding-right: 20px;\n  }\n\n  .ket-widget-custom-css{\n    height: 550px !important;\n  }\n\n  span.react-bootstrap-table-sort-order.dropup {\n    background-image: url(\"../../assets/images//Artboard 3down.png\");\n    width: 16px;\n    height: 20px;\n    float: left;\n    background-position: center;\n    position: absolute;\n    background-size: 80px 60px;\n    visibility: hidden;\n}\n\nspan.react-bootstrap-table-sort-order {\n    background-image: url(\"../../assets/images//Artboard 3up.png\");\n    width: 16px;\n    height: 20px;\n    float: left;\n    position: absolute;\n    background-position: center;\n    background-size: 80px 60px;\n    visibility: hidden;\n}\n\n.filter-button-NAS {\n    border: none;\n    color: white;\n    text-align: center;\n    margin: 0px;\n    cursor: pointer;\n    border-radius: 1rem;\n    height: 1.8rem;\n    padding-top: 0.2rem;\n    padding-bottom: 1.5rem;\n    padding-left: 2rem;\n    padding-right: 2rem;\n    font-weight: bold;\n}\n\n.toolboxImplNasCss{\n    top: 27px !important;\n    left: 300px !important;\n}\n\n.widget-filter-menu {\n    left: 100px!important;\n    transform: translate3d(-70px, 25px, 0px) !important;\n}\n.widget-filter-menu-TME {\n    left: 100px!important;\n    transform: translate3d(60px, 25px, 0px) !important;\n}\n\n.widget-filter-menu-score {\n    transform: translate3d(24px, 20px, 0px) !important;\n}\n\n.widget-filter-menu-score-per-nmsc {\n    transform: translate3d(90px, 20px, 0px) !important;\n}\n\n.widget-filter-menu-kaizen-overview {\n    transform: translate3d(127px, 20px, 0px) !important;\n}\n\n/** For 67%  */\n@media screen and (max-width: 2037px) and (min-width: 2030px) {\n    .date-range-container {\n        width: 24.5%;\n        margin: 0 auto;\n      }\n}\n/** For 75%  */\n@media screen and (max-width: 1850px) and (min-width: 1810px) {\n    .date-range-container {\n        width: 25.5%;\n        margin: 0 auto;\n      }\n}\n\n/** For 80%  */\n@media screen and (max-width: 1700px) and (min-width: 1697px) {\n    .date-range-container {\n        width: 26%;\n        margin: 0 auto;\n      }\n}\n\n/** For 90%  */\n@media screen and (max-width: 1600px) and (min-width: 1508px) {\n    .date-range-container {\n        width: 27.5%;\n        margin: 0 auto;\n      }\n}\n\n/** For 100% */\n@media screen and (max-width: 1358px) and (min-width: 1300px) {\n    .date-range-container {\n        width: 28.5%;\n        margin: 0 auto;\n      }\n}\n\n/** For 110% */\n@media screen and (max-width: 1235px) and (min-width: 1200px) {\n    .date-range-container {\n        width: 29.5%;\n        margin: 0 auto;\n      }\n}\n/** For 125% */\n@media screen and (max-width: 1100px) and (min-width: 1086px) {\n    .date-range-container {\n        width: 28%;\n        margin: 0 auto;\n      }\n}\n\n/** For 150% */\n@media screen and (max-width: 1000px) and (min-width: 905px) {\n    .date-range-container {\n        width: 28.5%;\n        margin: 0 auto;\n      }\n}\n\n/** For NAS dealer */\n.actionItemTableNAS {\n    padding: 1rem;\n    height: 50px !important;\n    background-color: #f0f0f0 !important;\n    font-weight: bold;\n}\n\n.actionItemTableNAS .react-bootstrap-table th[data-row-selection] {\n     width: 6.875rem;\n    }\n\n.actionItemTableNAS .react-bootstrap-table tbody {\n     height: 11rem !important;\n    }\n    \n/* Table header stick  */\n/* Sticky Header Styles for Score Table */\n.sticky-header-table .table thead th {\n    position: sticky !important;\n    top: -10 !important;\n    background-color: #f8f9fa !important;\n    z-index: 100 !important;\n    border-bottom: 2px solid #dee2e6 !important;\n    box-shadow: 0 2px 4px rgba(0,0,0,0.1) !important;\n}\n\n.sticky-header-table .table {\n    margin-bottom: 0 !important;\n}\n\n.sticky-header-table {\n    width: 100% !important;\n    position: relative !important;\n}\n\n.sticky-table-header {\n    position: sticky !important;\n    top: 0 !important;\n    background-color: white !important;\n    z-index: 100 !important;\n}\n\n/* Ensure proper scrolling behavior */\n.sticky-header-table .table-responsive {\n    overflow-y: auto !important;\n    max-height: 100% !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
